export default __webpack_public_path__ + "static/media/fitnessdropdown.71dccebc.png";